import { h } from "@stencil/core";
import { mouseEventModifierKey } from "../../../common/helpers";
/**
 * The `ch-tabular-grid-column-resize` component responsible for resizing a column in a grid.
 */
export class ChTabularGridColumnResize {
    constructor() {
        this.resizing = false;
        this.column = undefined;
    }
    startPageX;
    mousemoveFn = this.mousemoveHandler.bind(this);
    el;
    /**
     * Event emitted when the user starts resizing the column.
     */
    columnResizeStarted;
    /**
     * Event emitted when the user is resizing the column.
     */
    columnResizing;
    /**
     * Event emitted when the user finishes resizing the column.
     */
    columnResizeFinished;
    componentDidLoad() {
        this.el.addEventListener("mousedown", this.mousedownHandler.bind(this));
    }
    clickHandler(eventInfo) {
        eventInfo.stopPropagation();
    }
    dblclickHandler(eventInfo) {
        eventInfo.stopPropagation();
        if (mouseEventModifierKey(eventInfo)) {
            this.column.size = "auto";
        }
        else {
            this.column.size = "max-content";
        }
    }
    columnResizeStartedHandler() {
        this.resizing = true;
    }
    columnResizeFinishedHandler() {
        this.resizing = false;
    }
    mousedownHandler(eventInfo) {
        eventInfo.stopPropagation();
        eventInfo.preventDefault();
        this.startPageX = eventInfo.pageX;
        document.addEventListener("mousemove", this.mousemoveFn, { passive: true });
        document.addEventListener("mouseup", this.mouseupHandler.bind(this), {
            once: true
        });
        this.columnResizeStarted.emit({ columnId: this.column.columnId });
    }
    mousemoveHandler(eventInfo) {
        this.columnResizing.emit({
            columnId: this.column.columnId,
            deltaWidth: this.startPageX - eventInfo.pageX
        });
    }
    mouseupHandler() {
        document.removeEventListener("mousemove", this.mousemoveFn);
        this.columnResizeFinished.emit({ columnId: this.column.columnId });
    }
    render() {
        return h("div", { key: '6676d06c4cc8f103da5b7ceb576061a99fca99eb', class: "resize-mask", hidden: !this.resizing });
    }
    static get is() { return "ch-tabular-grid-column-resize"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-column-resize.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-column-resize.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChTabularGridColumnElement",
                    "resolved": "HTMLChTabularGridColumnElement",
                    "references": {
                        "HTMLChTabularGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChTabularGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The column element that is being resized."
                }
            }
        };
    }
    static get states() {
        return {
            "resizing": {}
        };
    }
    static get events() {
        return [{
                "method": "columnResizeStarted",
                "name": "columnResizeStarted",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user starts resizing the column."
                },
                "complexType": {
                    "original": "TabularGridColumnResizeEvent",
                    "resolved": "TabularGridColumnResizeEvent",
                    "references": {
                        "TabularGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../tabular-grid-column-types",
                            "id": "src/components/tabular-grid/column/tabular-grid-column-types.ts::TabularGridColumnResizeEvent"
                        }
                    }
                }
            }, {
                "method": "columnResizing",
                "name": "columnResizing",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user is resizing the column."
                },
                "complexType": {
                    "original": "TabularGridColumnResizeEvent",
                    "resolved": "TabularGridColumnResizeEvent",
                    "references": {
                        "TabularGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../tabular-grid-column-types",
                            "id": "src/components/tabular-grid/column/tabular-grid-column-types.ts::TabularGridColumnResizeEvent"
                        }
                    }
                }
            }, {
                "method": "columnResizeFinished",
                "name": "columnResizeFinished",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user finishes resizing the column."
                },
                "complexType": {
                    "original": "TabularGridColumnResizeEvent",
                    "resolved": "TabularGridColumnResizeEvent",
                    "references": {
                        "TabularGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../tabular-grid-column-types",
                            "id": "src/components/tabular-grid/column/tabular-grid-column-types.ts::TabularGridColumnResizeEvent"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "dblclick",
                "method": "dblclickHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnResizeStarted",
                "method": "columnResizeStartedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnResizeFinished",
                "method": "columnResizeFinishedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
